import styled, { css, CSSProperties } from 'styled-components'

import { AllColors } from '../../types/Colors'
import { colorFromProp } from '../../utils/getColorVar'

export interface TypographyProps {
  size?: number
  lineHeight?: number
  weight?: number
  color?: AllColors
  gutterBottom?: boolean | number
  decoration?: 'dashed' | 'dotted' | 'double' | 'line-through' | 'none' | 'overline' | 'solid' | 'underline' | 'wavy'
  display?: 'block' | 'inline-block' | 'inline' | 'inline-flex' | 'flex' | 'grid' | 'inline-grid' | 'contents' | 'none'
  verticalAlign?: 'baseline' | 'sub' | 'super' | 'text-top' | 'text-bottom' | 'middle' | 'top' | 'bottom'
  preventBreak?: boolean
  'data-is-sensitive'?: boolean
  flexGrow?: boolean
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase' | 'initial' | 'inherit'
  style?: CSSProperties
  textAlign?: CSSProperties['textAlign']
}

const Typography = styled.p<TypographyProps>`
  margin: 0;
  margin-bottom: ${({ gutterBottom }) =>
    gutterBottom === true ? '16px' : +gutterBottom > 0 ? `${gutterBottom}px` : null};
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => `${size}px`};
  color: ${colorFromProp('color', 500, 'gray')};
  text-decoration: ${({ decoration }) => decoration};
  text-transform: ${({ textTransform }) => textTransform};

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${`${lineHeight}px`};
    `}

  ${({ display }) =>
    display &&
    css`
      display: ${display};
    `}

    ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}

  ${({ verticalAlign }) =>
    verticalAlign &&
    css`
      vertical-align: ${verticalAlign};
    `}

    ${({ flexGrow }) =>
    flexGrow &&
    css`
      flex-grow: 1;
    `}

    ${({ preventBreak }) =>
    preventBreak &&
    css`
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      overflow-wrap: break-word;
    `}
`

export default Typography
